import { useQuery } from '@tanstack/react-query';
import { $apiFetchClient } from 'src/services/api';

export interface IncotermOption {
  id: number;
  code: string;
  name: string;
}

// Endpoint existiert im Backend-Branch, ist aber noch nicht in den generierten
// Typen (openapi-Regeneration folgt nach Backend-Restore) — daher untyped GET
// mit lokalem Interface statt $api.useQuery (Übergangsmuster, s. inbound.ts).
export const useAvailableIncotermsQuery = () =>
  useQuery({
    queryKey: ['get', '/sale_orders/available_incoterms/'],
    queryFn: async () => {
      const response = await ($apiFetchClient as { GET: Function }).GET('/sale_orders/available_incoterms/', {});
      if (response.error) throw response.error;
      return (response.data ?? []) as IncotermOption[];
    },
    staleTime: 5 * 60 * 1000,
  });
